import { RebuildNotice } from '@/components/RebuildNotice'
export default function Page() { return <RebuildNotice title="Finance dashboard" hint="KPIs from the shared finance engine (rr-finance-engine)." /> }
